import { render, staticRenderFns } from "./NavReplaceLinkItem.vue?vue&type=template&id=aa78aa1a&scoped=true&"
import script from "./NavReplaceLinkItem.vue?vue&type=script&lang=js&"
export * from "./NavReplaceLinkItem.vue?vue&type=script&lang=js&"
import style0 from "./NavReplaceLinkItem.vue?vue&type=style&index=0&id=aa78aa1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa78aa1a",
  null
  
)

export default component.exports